export default {
  email: "",
  rememberMe: false,
  listWhat: "",
  showSignIn: false,
  showSignUp: false,
  isSignIn: false,
  user: {},
  briefs: [],
  detail: {},
  listStyle: "inline",
  snackInfo: {},
};
